import type { Staff } from '@/domain/entities/staff.entity'
import type { StaffDto } from './account.dto'

export const accountMapper = {
  toStaff(dto: StaffDto): Staff {
    // BE mengirim outlet_ids (string[]); nama di-resolve di UI dari daftar outlet.
    const outlets = dto.outlets
      ? dto.outlets.map((o) => ({ id: o.id, name: o.name }))
      : (dto.outlet_ids ?? []).map((id) => ({ id, name: id }))
    return {
      // membership_id adalah kunci untuk PUT/DELETE /users/:id.
      id: dto.membership_id ?? dto.id ?? dto.user_id ?? '',
      username: dto.username,
      name: dto.name,
      role: {
        id: dto.role?.id ?? dto.role_id ?? '',
        name: dto.role?.name ?? dto.role_name ?? '',
      },
      allOutlets: Boolean(dto.all_outlets),
      outlets,
      active: dto.active ?? true,
    }
  },
}
